import { useSlice } from "@voix/composables/useSlice";
import { useSliceStore } from "@voix/store/sliceStore";
import { computed, ref } from "vue";
import { usePageStore } from "./../store/pageStore.js";
export function useField(props) {
  const pageStore = usePageStore();
  const ignoreSetter = ref(false);
  const localValue = computed({
    get() {
      if (typeof props.fieldData !== "undefined") {
        if (props.fieldData[props.fieldData.type] !== void 0)
          return props.fieldData[props.fieldData.type];
      }
      if (props.fieldConfiguration?.default)
        return props.fieldConfiguration.default;
      return null;
    },
    set(value) {
      if (props.isPageField) {
        const newValue = Object.assign({}, props.fieldData);
        newValue[props.fieldData.type] = value;
        pageStore.updatePageField(
          newValue.id,
          props.fieldConfiguration.name,
          newValue
        );
      } else if (props.element && !ignoreSetter.value) {
        pageStore.updateField(
          props.element.id,
          props.fieldConfiguration.name,
          value
        );
      }
    }
  });
  const localCustomValue = computed({
    get() {
      const fieldType = props.fieldData.type;
      if (typeof props.fieldData !== "undefined") {
        if (props.fieldData[fieldType] !== void 0)
          return props.fieldData[props.fieldData.type];
      }
      if (typeof props.fieldConfiguration !== "undefined" && typeof props.fieldConfiguration.default !== "undefined")
        return props.fieldConfiguration.default;
      return {};
    },
    set(value) {
      if (props.isPageField) {
        const newValue = Object.assign({}, props.fieldData);
        newValue[props.fieldData.type] = value;
        pageStore.updatePageField(
          newValue.id,
          props.fieldConfiguration.name,
          newValue
        );
      } else if (props.element && !ignoreSetter.value) {
        pageStore.updateField(
          props.element.id,
          props.fieldConfiguration.name,
          value
        );
      }
    }
  });
  const customValue = computed(() => {
    const obj = localCustomValue.value;
    return new Proxy(obj, {
      set(target, key, value) {
        target[key] = value;
        localCustomValue.value = target;
        return true;
      }
    });
  });
  const enabled = computed({
    get: () => {
      if (!props.fieldConfiguration)
        return true;
      if (props.fieldData && props.fieldData.enabled !== void 0)
        return props.fieldData.enabled;
      return true;
    },
    set(value) {
      const pageStore2 = usePageStore();
      if (props.isPageField) {
        if (value === true) {
          pageStore2.enablePageField(
            props.fieldConfiguration.name
          );
        } else {
          pageStore2.disablePageField(
            props.fieldConfiguration.name
          );
        }
      } else {
        if (value === true) {
          pageStore2.enableField(
            props.element.id,
            props.fieldConfiguration.name
          );
        } else {
          pageStore2.disableField(
            props.element.id,
            props.fieldConfiguration.name
          );
        }
      }
    }
  });
  return { ignoreSetter, localValue, customValue, enabled };
}
export function resolveFieldsArray(element) {
  const sliceStore = useSliceStore();
  const sliceHelper = useSlice();
  const sliceConfig = sliceStore.getSlice(element.component);
  if (!element.fields)
    return {};
  if (sliceConfig)
    return sliceHelper.resolveFields(sliceConfig, element.fields);
  console.error("Slice configuration not found for component:", element.component);
  return {};
}
